export enum GOAL_STATUS {
  ACTIVE = 'Active',
  COMPLETE = 'Complete',
  VOID = 'Void',
}

export enum ObservationGoals {
  WEIGHT = 'Weight',
}

export enum GoalFrequency {
  TWICE_WEEKLY = 'Twice weekly',
  QUARTERLY = 'Quarterly',
}

export enum WeightGoalTypes {
  WEIGHT_RESTORATION = 'Weight restoration',
  WEIGHT_MAINTENANCE = 'Weight maintenance',
  WEIGHT_MONITORING = 'Weight monitoring',
}
